import { PlusIcon } from "@xola/icons";
import { PopoverList } from "@xola/ui-kit";
import { groupBy } from "lodash";
import React, { useState } from "react";
import { Experience, PriceVariation, PurchaseRule } from "types";
import { useSearch } from "../../../hooks/useSearch";
import { SearchInput } from "../../Common/SearchInput";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { PriceVariationModal } from "./PriceVariationModal";

interface CreatePriceVariationProps {
    experience: Experience;
    priceVariation: PriceVariation;
    schedulePurchaseRules: PurchaseRule[];
    onSubmit: (priceVariation: PriceVariation) => void;
    onPurchaseRuleGroupClick: (purchaseRules: PurchaseRule[]) => void;
}

export const CreatePriceVariation = ({
    experience,
    priceVariation,
    schedulePurchaseRules,
    onSubmit,
    onPurchaseRuleGroupClick,
}: CreatePriceVariationProps) => {
    const [visible, setVisible] = useState(false);
    const [search, setSearch] = useState("");
    const [showCreatePriceVariationModal, setShowCreatePriceVariationModal] = useState(false);
    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    const purchaseRuleGroups = groupBy(schedulePurchaseRules, (rule) => rule.name?.split("-")[0].trim());
    const filtered = useSearch(
        Object.keys(purchaseRuleGroups),
        (purchaseRuleGroupName) => [purchaseRuleGroupName],
        search,
    );

    const handleSubmit = (priceVariation: PriceVariation) => {
        onSubmit(priceVariation);
        setShowCreatePriceVariationModal(false);
    };

    const handlePurchaseRuleGroupClick = (purchaseRuleGroupName: string) => {
        hide();
        onPurchaseRuleGroupClick(purchaseRuleGroups[purchaseRuleGroupName]);
    };

    return (
        <div className="self-start">
            <PopoverList
                visible={visible}
                className="min-w-75 overflow-y-auto bg-white"
                placement="auto"
                onClickOutside={hide}
            >
                <SecondaryButton size="small" icon={<PlusIcon />} onClick={visible ? hide : show}>
                    Add Price Variation
                </SecondaryButton>
                <PopoverList.Item name="ScheduleSearch" onClickItem={() => null}>
                    <SearchInput onChange={(searchResult: string) => setSearch(searchResult)} />
                </PopoverList.Item>
                {filtered?.map((purchaseRuleGroupName) => (
                    <PopoverList.Item
                        key={purchaseRuleGroupName}
                        name="ScheduleSearch"
                        className="no-translate"
                        onClickItem={() => handlePurchaseRuleGroupClick(purchaseRuleGroupName)}
                    >
                        {purchaseRuleGroupName}
                    </PopoverList.Item>
                ))}
                <PopoverList.Item name="createPriceVariation" onClickItem={() => null}>
                    <SecondaryButton
                        className="w-full"
                        icon={<PlusIcon />}
                        onClick={() => setShowCreatePriceVariationModal(true)}
                    >
                        Create Price Variation
                    </SecondaryButton>
                </PopoverList.Item>
            </PopoverList>

            <PriceVariationModal
                title="Create Price Variation"
                isEditPriceVariation={false}
                isOpen={showCreatePriceVariationModal}
                experience={experience}
                priceVariation={priceVariation}
                onClose={() => setShowCreatePriceVariationModal(false)}
                onSubmit={handleSubmit}
            />
        </div>
    );
};
